export const workspaceApi = async (path, options = {}) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    ...options, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}`, ...options.headers }
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = result.detail;
    const message = typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(x => x.msg).join(', ') : detail?.msg;
    const error = new Error(message || 'Request failed. Please try again.');
    error.detail = detail;
    throw error;
  }
  return result;
};